import * as $ from 'jquery';
import 'bootstrap';
import { bookingFormCommon } from '../c005-bookingform-common';
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";

export class memberReferrals {
    private bookingformcommon = new bookingFormCommon();
        private referralResp:any=null;

    init(): any{
        let _self=this;
        let referralUrl = '';
        $(scope).find('#link-share').after('<span class="fade" id="copy-alert">Message is copied</span>')


        let tnc = $(scope).find("#tnc")
        let tncUrl = tnc.data("link-url");

        tnc.attr("href",tncUrl);

        if (window.location.hostname === 'localhost' && window.location.port == "5000"){
             referralUrl = '/dummy-data/referrals.json';
    
        }else{
             referralUrl = '/bin/services/inviteandearn/enrichreferral';
        }
        _self.bookingformcommon.preloader();
        
        
        $.get(referralUrl)
        .done((data:any)=>{
            _self.bookingformcommon.preloaderClose();
            if (typeof data === 'string') {
                data=JSON.parse(data);
            }
            if(data.statusMessage==='OK'){
                _self.referralResp={
                    inviteLink : data.data[0].referralLink,
                    acceptedInvites  : data.data[0].referralAccepted,
                    referralPoints : data.data[0].referralPoints,
                    bookingPoints : data.data[0].bookingPoints,
                    shareMessage : data.data[0].shareMessage
                };
               $(scope).find('#enrollment').text(_self.referralResp.referralPoints);
                $(scope).find('#first-flight').text(_self.referralResp.bookingPoints);
                $(scope).find('#link ').text(_self.referralResp.inviteLink);
                $(scope).find('#referrals-enrolled #qty').text(_self.referralResp.acceptedInvites);
            }
            else{
                $('#above-18').hide();
                $('#below-18').removeClass('hide');
            }
            adobeDataLayer.push('pageLoaded', {
                'pageName': '',
                'pageType': 'Enrich Profile - Invite & Earn',
                'attributes': [
                    {
                        'key': 'referred-enrolled-to-date',
                        'value': _self.referralResp.acceptedInvites
                    }
                ]
            });
        })
        .fail(()=>{
            $(scope).find('#referral-err').show();
        })
    }
    handleCopyLink(): any{
        let _self = this;
        $("#link-share #copy-btn").click(function(){
            let copytxt =  _self.referralResp.shareMessage + '\n\n' + _self.referralResp.inviteLink;
            navigator.clipboard.writeText(copytxt);
            $('#copy-alert').addClass('in');
            setTimeout(function(){
                
                $('#copy-alert').removeClass('in');
            },2000)
        })
    }
}

let scope:Element = document.querySelector('#members--referral-container');

if (scope) {
	try {
	let memref = new memberReferrals();
    var adobeDataLayer = new adobeDataLayerWrapper();
    memref.init();
    memref.handleCopyLink();
	} catch(e) {console.error(e);}
}

// End Point: /bin/services/inviteandearn/enrichreferral
// Method: GET

// Success Response (Above 18 Years):
